import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { MBImage } from '@shared/components/image';
import { Signature, SignatureField } from '@shared/data/entity/fields/SignatureField';
import { Colors, grid } from '@shared/styles';
import { useImageSrcAndDimensions } from '@shared/util/hooks';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: SignatureField;
  style: StyleProp<ViewStyle>;
  showBorder?: boolean;
}

const sigStyles: StyleProp<ViewStyle> = {
  paddingVertical: grid(0.5),
  alignItems: 'center',
  borderColor: Colors.v2.gray10,
  borderStyle: 'solid',
  borderRadius: 10,
};

export function SignatureCollectionViewField({ field, style, showBorder = true }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer
      style={[sigStyles, style, { borderWidth: showBorder ? 1 : 0 }]}
    >
      <SignatureImage image={field.signature} />
    </CardCollectionViewFieldContainer>
  );
}

function SignatureImage({ image }: { image: Signature }) {
  const { src } = useImageSrcAndDimensions({ image });
  return <MBImage source={{ uri: src }} style={{ height: 30, width: 163.5 }} />;
}
